import { EventViewModel } from "../models/eventViewModel";
import { EventWithRecordingViewModel } from "../models/eventWithRecordingViewModel";
import { RecordingEntity } from "../models/recording";
import { mapRecordingEntityToViewModel } from "./recordingAdapter";

const synthesizeEventFromRecording = (r: RecordingEntity): EventViewModel => {
  const ddb = r.ddbRecord;
  const rawData = r.rawEventInfo?.data ?? {};

  return {
    id: ddb.GSIPK5 ?? "",
    timestamp: ddb.sk?.split("#R#")[1] ?? "",
    modelId: ddb.GSIPK2?.split("#R#")[1] ?? r.modelId ?? "",
    facilityId: ddb.GSIPK4?.split("#L#")[1] ?? r.facilityId ?? "",
    customerId: r.customerId ?? "",
    location: ddb.GSIPK4 ?? "",
    camera_id: rawData.camera_id ?? rawData.instance_name ?? "",
    recordingsCount: 0,
    leaksVolumeSum: 0,
  };
};

export const mapRecordingToEventWithRecording = (
  r: RecordingEntity
): EventWithRecordingViewModel => ({
  event: synthesizeEventFromRecording(r),
  newestRecording: mapRecordingEntityToViewModel(r),
});
